import React from "react";

const MetricCard = ({
  icon,
  count,
  title,
  cardType,
  selectedCard,
  onClick
}) => {
  const isSelected = selectedCard === cardType;

  return (
    <div
      className={`group relative overflow-hidden flex flex-col w-full px-[18px] py-[20px] rounded-2xl cursor-pointer transition-all duration-300 transform hover:scale-[1.02] hover:shadow-xl ${
        isSelected
          ? "bg-blue text-white shadow-blue/25"
          : "bg-white/90 backdrop-blur-sm border border-gray-100 hover:border-blue/30 shadow-lg"
      }`}
      onClick={onClick}
    >
      <div className="absolute top-0 right-0 w-24 h-24 bg-yellow/10 rounded-full blur-2xl opacity-50"></div>
      <div className="relative z-10">
        <div className="flex flex-col items-start mb-3">
          <div
            className={`p-3 rounded-xl mb-2 ${
              isSelected ? "bg-white/20" : "bg-blue/10"
            }`}
          >
            <i
              className={`${icon} text-[28px] ${
                isSelected ? "text-white" : "text-blue"
              }`}
            ></i>
          </div>
        </div>
        <div className="flex flex-row justify-between w-full mb-3">
          <h1
            className={`font-bold text-[28px] ${
              isSelected ? "text-white" : "text-blue"
            }`}
          >
            {count}
          </h1>
          {isSelected && (
            <div className="w-2 h-2 bg-yellow rounded-full animate-pulse mt-2"></div>
          )}
        </div>
        <h1
          className={`font-medium text-[16px] ${
            isSelected ? "text-blue-100" : "text-grey"
          }`}
        >
          {title}
        </h1>
      </div>
    </div>
  );
};

export default MetricCard;
